"use strict";

import Inputmask from "inputmask";

export function initInScope ($scope) {
    let $keycards = $scope.find('.js-keycard');

    $keycards.each(function () {
        console.log("hadfasdfsdf", $(this));
        Inputmask().mask($(this));
    });
}